import axios from "axios";

const Api = axios.create({
    baseURL: 'https://admin.vw-ekyc.net/api/'
    // baseURL: 'https://careerstrip.com/api/'
    // baseURL: 'http://127.0.0.1:8000/api/'
});

export default Api;